<template>
  <v-container class="not-found-container">
    <v-app-bar v-if="!mdAndUp" class="not-found-container__mobile-bar pl-2">
      <app-logo class="mb-2" />
    </v-app-bar>
    <v-row v-if="mdAndUp" justify="center" class="not-found-container__logo">
      <v-col cols="12" class="text-center pt-0">
        <app-logo />
      </v-col>
    </v-row>
    <teleport to=".v-application">
      <div class="user-block-container">
        <v-row align="center">
          <v-col class="pr-0">
            <v-btn
              class="user-block-container__toggle-theme mx-1"
              @click="toggleTheme"
              :icon="dark ? 'mdi-weather-sunny' : 'mdi-weather-night'"
              variant="text"
            />
          </v-col>
          <v-col>
            <user-block>
              <v-avatar color="primary" class="user-block__avatar" size="42" v-if="user">
                {{ user?.firstName.charAt(0) + user?.lastName.charAt(0) }}
              </v-avatar>
              <v-avatar class="user-block__avatar" size="42" v-else>
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
            </user-block>
          </v-col>
        </v-row>
      </div>
    </teleport>
    <v-row align-content="center" justify="center" class="not-found-container__content">
      <v-col cols="auto" class="d-flex align-center">
        <v-card flat class="mx-auto" :min-width="smAndUp ? '450' : 'auto'">
          <v-card-title>
            <v-row justify="center" class="pt-5 pb-5">
              <v-col cols="auto" class="pb-0">
                <img :src="dark ? illustrationDark : illustrationLight" height="230px" />
              </v-col>
            </v-row>
            <span class="d-block text-center text-h5 mt-4 mb-2">
              {{ $t('messages.somethingWentWrong') }}
            </span>
            <span class="d-block text-center text-caption text-disabled text-wrap mb-5 pb-4">
              {{ $t('messages.sorryNotFound') }}
            </span>
          </v-card-title>
          <v-card-text>
            <!-- Back and home button flexed -->
            <v-row justify="center" align="center" class="pb-2 px-2">
              <v-col cols="6" class="pr-1">
                <v-btn color="primary" variant="outlined" block @click="router.go(-1)">
                  <template #prepend>
                    <v-icon>mdi-arrow-left</v-icon>
                  </template>
                  {{ $t('messages.goBack') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn color="primary" block @click="router.push({ path: '/profileSelection' })">
                  <template #prepend>
                    <v-icon>mdi-home</v-icon>
                  </template>
                  {{ $t('messages.home') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer color="transparent">
      <v-row justify="center">
        <v-col cols="auto">
          <span class="text-caption text-disabled">
            Copyright © {{ year }} DeltaX. All rights reserved.
          </span>
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { useRouter } from 'vue-router'

import { useAppStore } from '@/stores/app'
import { useAppTheme } from '@/composables/useTheme'
import appConfig from '@/constants/appConfig'

import AppLogo from '@/components/AppLogo.vue'
import UserBlock from '@/components/UserBlock.vue'

const illustrationLight = appConfig.NOT_FOUND_DARK
const illustrationDark = appConfig.NOT_FOUND_LIGHT

const { dark, toggleTheme } = useAppTheme()
const appStore = useAppStore()
const { mdAndUp, smAndUp } = useDisplay()
const router = useRouter()

const user = computed(() => {
  return appStore.user
})

const year = new Date().getFullYear()
</script>

<style lang="scss" scoped>
.not-found-container {
  align-items: flex-start !important;
  &__mobile-bar {
    .v-toolbar__content {
      justify-content: center !important;
    }
  }
  &__logo,
  &__content {
    width: 100%;
  }
  &__content {
    height: 82vh;
    margin: auto;
    > .v-col {
      height: 100%;
    }
  }
}
.user-block-container {
  display: flex;
  position: absolute !important;
  right: 10px;
  top: 8px;
  z-index: 1010 !important; // Needs to be greater than app-bar in mobile view
}
</style>
